export const GIFT_STATUS_FREE = 'free';
export const GIFT_STATUS_DONE = 'done';
export const GIFT_STATUS_BOOKED = 'booked';
export const GIFT_STATUS_CONFIRMED = 'confirmed';
export const GIFT_STATUS_ALL = 'all';
export const GIFT_STATUS_NEW = 'new';
